export default {

    state: () => ({
        currentOrder: {
            id: 0,
            deliveryType: '',
            address: '',
            deliverySum: 0,
            paymentType: '',
            comment: 0,
            basketSum: 0,
            totalSum: 0
        },
    }),

    actions: {
        SET_CURRENT_ORDER: (context, order) => {
            context.commit('SET_ORDER', order);
        },
    },

    mutations: {
        SET_ORDER: (state, order) => {
            state.currentOrder.id = order.ORDER.ID;
            state.currentOrder.comment = order.ORDER.USER_DESCRIPTION;
            state.currentOrder.deliveryType = order.SHIPMENT[0].DELIVERY_NAME;
            state.currentOrder.address = order.SHIPMENT[0].ADDRESS;
            state.currentOrder.deliverySum = order.SHIPMENT[0].PRICE_DELIVERY > 0?
                order.SHIPMENT[0].FORMATED_DELIVERY_PRICE : 'Бесплатно';
            state.currentOrder.paymentType = order.PAYMENT[0].PAY_SYSTEM_NAME;
            state.currentOrder.totalSum = order.PAYMENT[0].FORMATED_SUM;
            state.currentOrder.basketSum = order.FORMATED_BASKET_SUM;
            window.popup.open('#more');
        },
    },

    getters: {}

}